import { render } from "./UserFiles.vue?vue&type=template&id=f8f06714"
import script from "./UserFiles.vue?vue&type=script&lang=js"
export * from "./UserFiles.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/driver.blackwidow.org.za/releases/80919820/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
